import application from 'application/application';

application.service('filterSelect', [
	function() {
		this.removeOption = arr => {
			const title = {
				tipo: 'Todas movimentações',
				lido: 'Todas situações',
				palavraChave: 'Todas palavras-chaves',
				diario: 'Todos diários',
				caderno: 'Todos cadernos',
				fonte: 'Todas fontes',
				identificador: 'Todos identificadores',
				orgaoJudicial: 'Todos tribunais',
				andamento: 'Tipo de Andamento',
				inssDadoAcesso: 'Login',
				inssProcessos: 'Processos',
				inssSistema: 'Sistema',
				inssBuscaAndamento: 'Busca de Andamentos'
			};

			arr.forEach(value => {
				var element = document.getElementById(`select2-${value}-container`);

				if (value && !!title[value] && !!element) {
					element.textContent = title[value];

					element.title = title[value];
				}
			});
		};
	}
]);
